var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalkWithUsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15751_1019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5 35.5C35.5 34 40.5 31 40.5 27.75C40.5 24 37 21 32.75 19.75C34.5 17.75 35.5 15.5 35.5 12.75C35.5 5.75 28.25 0 19 0C10.25 0 0.5 5.25 0.5 12.75C0.5 18 4.5 21.75 6.25 23.25C6 26.25 4.75 27.5 4.75 27.5L1.75 30H5.5C9.5 30 12.75 28.75 14.75 27.25V27.75C14.75 32.75 20.25 36.75 27.25 36.75H28.75C29.75 38 33 40.25 37.25 40.25C37.5 40 35.5 39 35.5 35.5ZM19 2.5C26.75 2.5 33 7.25 33 12.75C33 18.25 26.5 23 18.5 23H15.75L15.5 23.5C14.75 24.5 11.75 26.5 7.75 27.25C8 26.25 8 24.75 8 22.75V22C5.5 20 2.75 16.5 2.75 13C2.75 7.5 10.75 2.5 19 2.5Z",
    fill: "#1E1E1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15751_1019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkWithUsIcon);
export default __webpack_public_path__ + "static/media/talk-with-us-icon.9c8f626c98e5b98a2c7fb35013294b25.svg";
export { ForwardRef as ReactComponent };